// ホールディングス案件登録画面のラベル
export const LABELS = {
  LAST_UPDATED_DATE: "最終更新日",
  LAST_UPDATED_BY: "最終更新者",
  MERCHANT_COMPANY_INFO: "加盟店傘下事業者情報",
  CORPORATE_NUMBER: "法人番号",
  BUSINESS_NAME: "事業者名",
  STATUS: "ステータス",
  COMPANY_CODE: "事業者コード",
  CONTRACT_SERVICE: "契約サービス",
  GROUP_NAME: "グループ名",
  TITLE: "登録済事業者一覧",
  SERVICE_NAME_BARCODE: "d払い（バーコード）",
  REFERENCE_GROUP_INFO: "参照グループ情報",
  REFERENCE_GROUP_TYPE: "参照グループ種別",
  UNIFIED_HOLDINGS: "ホールディングス全体で統一",
  SELECT_BY_COMPANY: "傘下企業ごとに作成可能",
} as const;

// 契約ステータスインターフェース
interface ContractStatusObj {
  statusCode: string;
  statusName: string;
}

export interface contractStatus {
  beforeContract: ContractStatusObj;
  underContract: ContractStatusObj;
  stopContract: ContractStatusObj;
  cancelContract: ContractStatusObj;
}

export const contractStatusPattern: contractStatus = {
  beforeContract: {
    statusCode: "0",
    statusName: "契約前",
  },
  underContract: {
    statusCode: "1",
    statusName: "契約中",
  },
  stopContract: {
    statusCode: "2",
    statusName: "停止中",
  },
  cancelContract: {
    statusCode: "3",
    statusName: "解約済",
  },
};

// 画面表示ステータス
export const getStatus = (statusNumber: string): string => {
  switch (statusNumber) {
    case contractStatusPattern.beforeContract.statusCode:
      return contractStatusPattern.beforeContract.statusName;
    case contractStatusPattern.underContract.statusCode:
      return contractStatusPattern.underContract.statusName;
    case contractStatusPattern.stopContract.statusCode:
      return contractStatusPattern.stopContract.statusName;
    case contractStatusPattern.cancelContract.statusCode:
      return contractStatusPattern.cancelContract.statusName;
    default:
      // 想定外の数値の場合は空文字を設定する。
      return "";
  }
};
